import { MultiPolygon, Polygon } from './create-zone-dto.interface';
import { ITagOutputDto } from './tags-output-dto.interface';

export interface IZoneOutputDto {
    id?: string;
    type: string;
    geometry: IGeometryOutputDto;
    properties: IPropertiesOutputDto;
    createdAt?: string;
    updatedAt?: string;
    tags?: string[] | ITagOutputDto[];
}

export interface IPropertiesOutputDto {
    organizationId: string;
    name: string;
    tags?: string[] | ITagOutputDto[];
    type?: string;
    externalId?: string;
    code?: string;
    color: string;
    isStopOver?: boolean;
    maxSpeed?: {
        enabled: boolean;
        value: number;
    };
}

export interface IGeometryOutputDto {
    type: string;
    coordinates: MultiPolygon | Polygon;
}
